<template>
  <base-modal @close="$emit('close')" class="w-full" head="Register Device" :zIndex="9991">
    <form class="w-full mr-12" @submit.prevent="onSubmit">
      <FormError :errors="errors" />
      <div class="flex py-3">
        <div class="space-y-1 w-full">
          <div>
            <!-- <span class="ml-2 whitespace-nowrap"
              >Android ID: <span class="text-red-default">*</span></span
            > -->
            <base-input
              class="mt-3 pb-2 lg:pb-3"
              :required="true"
              label="android_id_select"
              v-model="tabletForm.android_id"
              clearable
            >
            </base-input>
          </div>
          <div>
            <!-- <label class="ml-2 whitespace-nowrap"
              >Device Name: <span class="text-red-default">*</span></label
            > -->
            <base-input :required="true" label="device_name" v-model="tabletForm.name" clearable>
            </base-input>
          </div>
          <div>
            <base-input
              :required="false"
              label="android_version"
              v-model="tabletForm.android_version"
              clearable
            >
            </base-input>
          </div>
          <div class="">
            <base-input
              class="lg:pb-3 w-full"
              :required="false"
              label="device_model"
              v-model="tabletForm.model"
              clearable
            >
            </base-input>
          </div>
        </div>

        <div v-if="!$store.getters['auth/isUser']" class="ml-14 min-w-max">
          <!-- <span class="ml-2 whitespace-nowrap"
              >Company (admin only): <span class="text-red-default">*</span></span
            > -->
          <base-label text="company_select" />
          <SingleSelect
            :required="true"
            :options="$store.getters['companies/list']"
            class="mt-2 p-4 text-sm shadow-md border"
            v-model="tabletForm.company"
            clearable
          />
        </div>
      </div>
      <div class="flex justify-end my-2">
        <base-button context="outline" action="close" @click="$emit('close')" class="self-start">
          <base-icon icon="close" />
        </base-button>
        <base-button :loading="loadingActivation" type="submit" class="ml-4">
          <base-icon icon="success" /> <span>Activate</span>
        </base-button>
      </div>
    </form>
  </base-modal>
</template>

<script>
import {
  BaseButtonIcon,
  BaseButton,
  BaseModal,
  BaseInput,
  BaseIcon,
  BaseLabel,
} from '@/components/base'
import SingleSelect from '@/components/shared/SingleSelect.vue'
import FormError from '@/components/shared/FormError.vue'
import _baseLabel from '@/components/base/_base-label'

export default {
  components: {
    BaseButtonIcon,
    BaseButton,
    BaseModal,
    BaseInput,
    BaseIcon,
    SingleSelect,
    FormError,
    'base-label': _baseLabel,
  },

  data() {
    return {
      loadingActivation: false,
      tabletForm: {
        name: '',
        android_id: '',
        company: '',
        android_version: '',
        model: '',
      },
      errors: {},
    }
  },
  methods: {
    async onSubmit() {
      this.loadingActivation = true
      let payload = this.tabletForm
      try {
        await this.$store.dispatch('tablets/activateTablet', payload)
        await this.$store.dispatch('app/notification', {
          type: 'success',
          group: 'app',
          text: `tablet_created`,
        })
        this.errors = {}
        this.$emit('activation')
        this.$emit('close')
      } catch (errors) {
        console.log(errors)
        this.errors = errors
      } finally {
        this.loadingActivation = false
      }
    },
  },
}
</script>

<style scoped></style>
